import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      icon: 'Users',
      label: 'Total Members',
      value: stats?.totalMembers,
      color: 'var(--color-primary)'
    },
    {
      icon: 'Shield',
      label: 'Officers',
      value: stats?.officers,
      color: 'var(--color-accent)'
    },
    {
      icon: 'Activity',
      label: 'Online Now',
      value: stats?.onlineNow,
      color: 'var(--color-success)'
    },
    {
      icon: 'UserPlus',
      label: 'New This Month',
      value: stats?.newThisMonth,
      color: 'var(--color-warning)'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
      {statCards?.map((stat, index) => (
        <div key={index} className="card hover:shadow-warm-md transition-base">
          <div className="flex items-center gap-3 md:gap-4">
            <div 
              className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{ background: `${stat?.color}20` }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
            <div className="min-w-0">
              <p className="text-2xl md:text-3xl font-bold text-foreground">
                {stat?.value}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground truncate">
                {stat?.label}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;